  $(window).load( function(){
  $('#add-to-cart').click( addToCart ); 
});

function addToCart(e){
  $.ajax({ 
    type: 'POST',
    url: '/cart/add.js',
    async: false, 
    cache: false, 
    data: $(this).parent().serialize(),
    dataType: 'json',
    error: addToCartFail,
    success: addToCartSuccess  
  });
  e.preventDefault();
}

function addToCartSuccess (jqXHR, textStatus, errorThrown){
  $.ajax({ 
    type: 'GET',
    url: '/cart.js',
    async: false, 
    cache: false, 
    dataType: 'json',
    success: updateCartDesc  
  });         
  $('#add-to-cart-msg').hide().addClass('success').html('<p>Item added to <a href="/cart" title="view cart">your cart</a></p>').fadeIn();
  //$('#add-to-cart-msg p').delay(4000).fadeOut(100);    
}

function addToCartFail(jqXHR, textStatus, errorThrown){
  $('#add-to-cart-msg').hide().addClass('error').html(jqXHR.description).fadeIn();
}

function updateCartDesc(data){
  var $cartLinkText = $('.top-cartlink-text');
  
  switch(data.item_count){
    case 0: 
      $cartLinkText.text('Cart Empty');
      break;
    case 1:
      $cartLinkText.text('1 item');
      break;
    default:
      $cartLinkText.text(data.item_count+' items');
      break;
  }
}


